import { ChangeDetectorRef, Component, effect, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TradeInSelectors } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.selectors';
import { IceRadioButtonComponent } from '@app/shared/components/atoms/ice-radio-button/ice-radio-button.component';
import { select } from '@ngxs/store';
import { SortByPipe } from '@sales/modules/mbb/pipes/sort-by.pipe';
import { InformationButtonComponent } from '../../../information-button/information-button.component';

@Component({
  selector: 'app-trade-in-condition',
  templateUrl: './trade-in-condition.component.html',
  styleUrl: './trade-in-condition.component.scss',
  imports: [FormsModule, ReactiveFormsModule, IceRadioButtonComponent, SortByPipe, InformationButtonComponent],
})
export class TradeInConditionComponent {
  private changeDetectorRef = inject(ChangeDetectorRef);

  @Input({ required: true }) tradeInConditionForm: FormGroup;

  @Output() infoClicked = new EventEmitter<string | undefined>();

  gradingQuestions = select(TradeInSelectors.gradingQuestions);
  selectedStep = select(TradeInSelectors.selectedStep);

  activeInformation: string;

  constructor() {
    effect(() => {
      if (!Number.isNaN(this.selectedStep())) {
        this.activeInformation = undefined;
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  toggleActiveInformation(questionType: string): void {
    this.activeInformation = questionType === this.activeInformation ? null : questionType;
    this.infoClicked.emit(this.activeInformation);
  }
}
